export const TID = {
  home: {
    hero: 'home-hero',
    menuBtn: 'home-hero-menu-button',
    bookBtn: 'home-hero-book-button',
    directionsBtn: 'home-hero-directions-button',
    featured: 'home-featured-dishes',
    delivery: 'home-delivery-cta-strip',
    deliveryUber: 'home-delivery-uber-eats',
    deliveryDeliveroo: 'home-delivery-deliveroo',
    deliveryJustEat: 'home-delivery-just-eat',
    reviews: 'home-google-reviews',
    gallery: 'home-gallery',
    hours: 'home-hours-location',
    social: 'home-social-links',
  },
  menu: {
    page: 'menu-page',
    tabs: 'menu-category-tabs',
    search: 'menu-search-input',
    card: 'menu-item-card',
    add: 'menu-item-add-to-cart-button',
  },
  order: {
    page: 'order-online-page',
    cartOpen: 'cart-open-button',
    place: 'checkout-place-order-button',
    fulfilment: 'checkout-fulfilment-toggle',
    allergy: 'checkout-allergy-notes-textarea',
    reference: 'order-confirmation-reference',
  },
  book: {
    page: 'book-table-page',
    wizard: 'booking-wizard',
    stepper: 'booking-stepper',
    date: 'booking-date-calendar',
    time: 'booking-time-slot-grid',
    guests: 'booking-guests-selector',
    details: 'booking-details-form',
    phone: 'booking-details-phone-input',
    next: 'booking-next-step-button',
    back: 'booking-back-step-button',
    confirm: 'booking-confirm-button',
    reference: 'booking-confirmation-reference',
  },
  contact: {
    page: 'contact-page',
    submit: 'contact-form-submit',
  },
  admin: {
    loginPage: 'admin-login-page',
    loginSubmit: 'admin-login-submit',
    overview: 'admin-overview-page',
    statCard: 'admin-stat-card',
    ordersPage: 'admin-orders-page',
    ordersBoard: 'admin-orders-board',
    reservationsPage: 'admin-reservations-page',
    menuItemsPage: 'admin-menu-items-page',
    categoriesPage: 'admin-categories-page',
    settingsPage: 'admin-settings-page',
    emailLogPage: 'admin-email-log-page',
    detailDrawer: 'admin-detail-drawer',
    dataTable: 'admin-data-table',
  },
  nav: {
    bottom: 'mobile-bottom-tab-nav',
    headerLogo: 'site-header-logo',
    cart: 'site-header-cart',
  },
  toaster: 'app-toaster',
};
